(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('profileOffice365EmailsUserUserMetaInfo', ["path", "widgetLogic", function (path, widgetLogic) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('profile/office365_emails_user/user-meta-info').template('user-meta-info'),
            scope: {},
            link: function ($scope, element, attrs) {
                $scope.model = {
                    'type': 'meta-info',
                    'logic': {
                        'name': 'userMetaInfoLogic',
                        'beautifyKey': true,
                        'extendedData': ['display_name'],
                        'useTroubleshootingMode': false
                    },
                    'uuid': 'c95ef4b7-c767-4104-9c64-381d4ebddde8',
                    'bodyStyle': { 'height': '260px' },
                    'wrapper': {
                        'type': 'widget-panel',
                        'title': 'User meta data',
                        'class': 'avanan white-body'
                    },
                    'pair': { 'class': 'user-meta-data key-width-190' }
                };
                widgetLogic($scope, $scope.model.logic);
                $scope.isDefined = function (data) {
                    return !_(data).isUndefined();
                };
                $scope.filters = {
                    uuid: $scope.model.uuid,
                    filters: []
                };
                $scope.$watch('model.wrapper.filters', function () {
                    $scope.filters.filters = $scope.model.wrapper.filters;
                });
            }
        };
    }]);
}());